<template>
  <v-card>
    <v-card-title>
      <span class="headline"><v-icon>mdi-database-edit</v-icon>委託・消化仕入明細一括編集</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-form ref="propositionDetailBulkEditForm" lazy-validation>
        <v-container>
          <section-block>
            <v-row v-for="(source, index) in settingSources" :key="index" dense>
              <v-col cols="3">
                <v-select
                  :items="constant.propositionDetailBulkEditColumnsValues"
                  label="設定項目"
                  v-model="source.column"
                  :rules="[rules.required, rules.validSelectColumn]"
                  @change="onSettingColSelected(index)"
                  dense
                  filled
                  attach
                ></v-select>
              </v-col>
              <v-col cols="5">
                <customer-field
                  label="取引先名"
                  v-if="source.column === constant.propositionDetailBulkEditColumns.CUSTOMER_NAME"
                  v-model="source.value"
                  :code="source.value"
                  :corporate="selectedProposition && selectedProposition.corporateCode"
                  @input="onBulkCustomerChanged"
                ></customer-field>
                <v-text-field
                  v-if="source.column === constant.propositionDetailBulkEditColumns.WHOLESALE_RATE"
                  label="卸掛率"
                  v-model="source.value"
                  @change="source.value = stringToNumber($event)"
                  :rules="[rules.isNumber, rules.isRate, rules.maxRateLength(3, 1), rules.rangeOfNumber(0, 100)]"
                  filled
                  dense
                >
                </v-text-field>
                <v-text-field
                  v-if="source.column === constant.propositionDetailBulkEditColumns.PURCHASE_RATE"
                  label="仕入掛率"
                  v-model="source.value"
                  @change="source.value = stringToNumber($event)"
                  :rules="[rules.isNumber, rules.isRate, rules.maxRateLength(3, 1), rules.rangeOfNumber(0, 100)]"
                  filled
                  dense
                >
                </v-text-field>
                <delivery-All-field
                  v-if="source.column === constant.propositionDetailBulkEditColumns.SUPPLIER_DELIVERY_CD"
                  ref="deliveryAll"
                  :group-codes="[]"  :code="source.value"
                  @selected="onDeliveryAllChanged"
                  attach
                >
                </delivery-All-field>
                <dp-date-picker
                v-if="source.column === constant.propositionDetailBulkEditColumns.SHIP_PLAN_DATE"
                label="出荷予定日"
                v-model="source.value"
                filled
                dense
                type="date"
              ></dp-date-picker>
              </v-col>
              <v-col cols="1"
                ><v-btn v-if="index != 0" x-small fab dense @click="onDelSettingSource(index)">
                  <v-icon dark> mdi-minus </v-icon></v-btn
                ></v-col
              >
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-btn x-small fab dense @click="onAddSettingSource">
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </section-block>
          <v-divider class="mt-3 pt-3"></v-divider>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-spacer></v-spacer>
              <tooltip-icon-button
                :disabled="selectedRows.length == 0"
                icon="mdi-arrow-down-bold-outline"
                @click="onBtnSetUpdate"
                >一括反映</tooltip-icon-button
              >
            </v-col>
            <v-col cols="12" sm="12" style="height: 450px">
              <ag-grid-vue
                :domLayout="domLayout"
                class="ag-theme-alpine"
                :defaultColDef="defaultColDef"
                :columnDefs="columnDefs"
                :alwaysShowHorizontalScroll="true"
                :suppressColumnVirtualisation="true"
                :pagination="true"
                paginationPageSize="10"
                :localeText="localeText"
                rowSelection="multiple"
                @grid-ready="onGridReady"
                @column-everything-changed="onColumnEverythingChanged"
                @selection-changed="onSelectionChanged"
                :columnTypes="columnTypes"
                :getRowNodeId="(data) => data.propositionDetailId"
                :frameworkComponents="frameworkComponents"
                @cell-value-changed="onCellValueChanged"
                style="height: 100%"
                @cell-editing-started="onCellEditingStarted"
              >
              </ag-grid-vue>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="secondary" @click="onCancelClick">キャンセル</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="onUpdateClick">更新</v-btn>
    </v-card-actions>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <error-grid-dialog
      ref="updateErrorGrid"
      width="80%"
      height="80%"
      icon=""
      title="委託・消化仕入明細一括編集"
      btnSubmit="登録"
      :columns="errorColumns"
    ></error-grid-dialog>
  </v-card>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { AG_GRID_LOCALE_JA } from "../../models/ag-grid/locales";
import {
  NumericColumn,
  PercentColumn,
  DateColumn,
  FullDateColumn,
  CheckmarkColumn,
  EditableColumn,
  EditableDateColumn,
  EditableCheckBoxColumn,
  EditableCustomDateColumn,
} from "../../models/ag-grid/columnTypes";
import { getColumnDef } from "../../models/ag-grid/helpers";
import TooltipIconButton from "../common/TooltipIconButton.vue";
import SectionBlock from "../common/SectionBlock.vue";
import {
  DateCellEditor,
  CheckboxCellEditor,
  CustomDateCellEditor,
  NumericCellEditor,
  IncludeFilter,
} from "../../components/ag-grid/cellEditors";
import ErrorGridDialog from "../../components/common/ErrorGridDialog.vue";
import { statuses as ApiStatus } from "../../libs/api-client";
import Validation from "../../libs/validation";
import {} from "../../components/ag-grid/cellEditors";
import { BooleanFilter, SelectionFilter } from "../../components/ag-grid/filters";
import propositionDetailBulkEditColumns from "../../consts/editColumns/PropositionDetailBulkEditColumns";
import ConvertUtils from "../../utils/ConvertUtils";
import CustomerField from "../common/fields/CustomerField.vue";
import DeliveryAllField from "../common/fields/DeliveryAllField.vue";
import StockOwners from "../../consts/StockOwners";
import { AutocompleteSelectCellEditor } from "ag-grid-autocomplete-editor";
import { DateValueFormatter } from "../../models/ag-grid/valueFormatters";
export default {
  name: "propositionDetailBulkEdit",
  props: ["inputModel", "inputHeader", "propositionList"],
  components: {
    AgGridVue,
    TooltipIconButton,
    ErrorGridDialog,
    SectionBlock,
    CustomerField,
    DeliveryAllField,
    /* eslint-disable vue/no-unused-components */
    CustomDateCellEditor,
  },
  data() {
    return {
      updateModel: {},
      defaultModel: {
        customerCode: null,
        wholesaleRate: null,
        purchaseRate: null,
        delivery1: null,
        shipmentPlanDate: null,
      },
      constant: {
        propositionDetailBulkEditColumnsValues: propositionDetailBulkEditColumns.all(),
        propositionDetailBulkEditColumns: propositionDetailBulkEditColumns,
      },
      modDeliveryCode: null,
      defaultColDef: null,
      columnDefs: null,
      gridApi: null,
      columnApi: null,
      selectedRows: [],
      domLayout: null,
      localeText: AG_GRID_LOCALE_JA,
      updateList: [],
      settingSources: [],
      quantityCopyReturn: false,
      quantityCopyBad: false,
      selectedProposition: null,
      selectedBulkCustomerCode: null,
      columnTypes: {
        dpNumericColumn: NumericColumn,
        dpPercentColumn: PercentColumn,
        dpDateColumn: DateColumn,
        dpFullDateColumn: FullDateColumn,
        dpCheckmarkColumn: CheckmarkColumn,
        dpEditableColumn: EditableColumn,
        dpEditableDateColumn: EditableDateColumn,
        dpEditableCheckBoxColumn: EditableCheckBoxColumn,
        dpEditableCustomDateColumn: EditableCustomDateColumn,
      },
      frameworkComponents: {
        dpDateCellEditor: DateCellEditor,
        dpCheckboxCellEditor: CheckboxCellEditor,
        dpBooleanFilter: BooleanFilter,
        dpSelectionFilter: SelectionFilter,
        dpCellDatePicker: CustomDateCellEditor,
        dpNumericCellEditor: NumericCellEditor,
      },
      errorRows: [],
      updateSuccessRecords: [],
      rules: {
        required: Validation.required, 
        isNumber: Validation.isNumber,
        maxLength: Validation.maxLength,
        isMinNumber: Validation.isMinNumber,
        maxRateLength: Validation.maxRateLength,
        isRate: Validation.isRate,
        validSelectColumn: (value) => this.validSelectColumn(value),
        rangeOfNumber: Validation.rangeOfNumber,
      },
      stringToNumber: ConvertUtils.stringToNumber,
      searchFlg: false,
      deliveryGroupCodes: [],
      deliveries: [],
      customers: [],
      CustomerRecords: [],
      cafereoColumns: [
        { headerName: "委託・消化仕入明細ID", field: "propositionDetailId" },
        { headerName: "委託JANCODE", field: "janCode", filterParams: IncludeFilter },
        { headerName: "委託タイトル", field: "title", filterParams: IncludeFilter },
        { headerName: "委託商品名", field: "productName", filterParams: IncludeFilter },
        {
          headerName: "取引先名",
          field: "customerName",
          editable: true,
          cellEditor: AutocompleteSelectCellEditor,
          cellEditorParams: () => {
            return {
              selectData: this.customers,
              placeholder: "取引先入力",
              required: true,
              autocomplete: {
                showOnFocus: true,
                fetch: (cellEditor, text, update) => {
                  let match = text || cellEditor.eInput.value;
                  const current = this.customers.filter(
                    (c) => c.label.includes(match) || c.customerCode.includes(match)
                  );
                  update(current);
                },
              },
            };
          },
          valueFormatter: (params) => params.value?.label || params.value || "",
          cellStyle: (params) => {
            let ret = { backgroundColor: "#FFFFCC" };
            if (params.data.updateCustomerCode) {
              ret.backgroundColor = "#CCFFCC";
            }
            return ret;
          },
        },
        {
          headerName: "卸掛率",
          field: "wholesaleRate",
          type: "dpPercentColumn",
          cellEditor: "dpNumericCellEditor",
          editable: true,
          cellStyle: (params) => {
            let ret = { backgroundColor: "#FFFFCC" };
            if (params.data.updateWholesaleRate) {
              ret.backgroundColor = "#CCFFCC";
            }
            return ret;
          },
        },
        { headerName: "仕入掛率", 
          field: "purchaseRate", 
          type: "dpPercentColumn",
          cellEditor: "dpNumericCellEditor",
          editable: true,
          cellStyle: (params) => {
            let ret = { backgroundColor: "#FFFFCC" };
            if (params.data.updatePurchaseRate) {
              ret.backgroundColor = "#CCFFCC";
            }
            return ret;
          },
        },
        { headerName: "委託数", field: "entrustQuantity", type: "dpNumericColumn" },
        { headerName: "販売実績数", field: "salesResults", type: "dpNumericColumn" },
        { headerName: "返品数", field: "returnQuantity", type: "dpNumericColumn" },
        { headerName: "検品数", field: "inspectionQuantity", type: "dpNumericColumn" },
        {
          headerName: "在庫所有元",
          field: "stockOwner",
          valueGetter: (params) => StockOwners.of(params.data.stockOwner),
        },
        {
          headerName: "配送先",
          field: "delivery1",
          editable: true,
          cellEditor: AutocompleteSelectCellEditor,
          filterValueGetter: (params) => {
            return params.data.delivery1
              ? String(params.data.delivery1.label)
              : String(params.data.delivery1.value.delivery1 + " " + params.data.delivery1.value.delivery2);
          },
          cellEditorParams: (params) => {
            const currentRowCustomerCode = params.data.customerCode;
            
           const filteredDeliveries = this.deliveries.filter((d) => {
              return d.groupCode === currentRowCustomerCode;
            });

            return {
              selectData: filteredDeliveries,
              placeholder: currentRowCustomerCode ? "配送先入力" : "先に取引先を選択してください",
              required: true,
              autocomplete: {
                showOnFocus: true,
                fetch: (cellEditor, text, update) => {
                  let match = (text || cellEditor.eInput.value || "").toLowerCase();
                  
                  const current = filteredDeliveries.filter((c) => {
                    return (
                      (c.label && c.label.toLowerCase().includes(match)) || 
                      (c.deliveryCode && c.deliveryCode.toLowerCase().includes(match))
                    );
                  });
                  update(current);
                },
              },
            };
          },
          valueFormatter: (params) => params.value?.label || params.value?.text || params?.value || "",
          comparator: (valueA, valueB, nodeA, nodeB) => {
            const valueALbel = valueA ? valueA.label : nodeA.data.delivery1 + " " + nodeA.data.delivery2;
            const valueBLbel = valueB ? valueB.label : nodeB.data.delivery1 + " " + nodeB.data.delivery2;
            if (valueALbel == valueBLbel) return 0;
            return valueALbel > valueBLbel ? 1 : -1;
          },
          cellStyle: (params) => {
            let ret = { backgroundColor: "#FFFFCC" };
            if (params.data.updateDelivery1) {
              ret.backgroundColor = "#CCFFCC";
            }
            return ret;
          },
        },
        { headerName: "返送先", field: "supplierDelivery1" },
        {
          headerName: "出荷予定日",
          field: "shipmentPlanDate",
          filter: "agDateColumnFilter",
          type: "dpEditableCustomDateColumn",
          cellEditorFramework: "CustomDateCellEditor",
          valueFormatter: DateValueFormatter("YYYY/MM/DD"),
          cellStyle: (params) => {
            let ret = { backgroundColor: "#FFFFCC" };
            if (params.data.updateShipmentPlanDate) {
              ret.backgroundColor = "#CCFFCC";
            }
            return ret;
          },
        },
      ],
      errorColumns: [
        { headerName: "委託・消化仕入明細ID", field: "propositionDetailId" },
        {
          headerName: "エラー内容",
          field: "errorMessage",
          wrapText: true,
          autoHeight: true,
          cellRenderer: function (param) {
            return param.data.errorMessage.join("<br>");
          },
        },
      ],
    };
  },
  watch: {
    inputModel(inputModel) {
      this.init(inputModel);
    },
  },
  computed: {
    isLoading() {
      return this.$store.getters["ui/isLoading"];
    },
    currentBulkGroupCodeArray() {
      return this.selectedBulkCustomerCode ? [this.selectedBulkCustomerCode] : [];
    }
  },
  methods: {
    // ****************************
    // ag-grid
    // ****************************
    setColumnDefs() {
      let columnDefs = [
        {
          headerName: "",
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          filter: false,
          resizable: false,
          sortable: false,
          pinned: "left",
        },
      ];
      columnDefs = columnDefs.concat(this.cafereoColumns);
      // ag-grid内のvalidation等をセット
      getColumnDef(columnDefs, "customerName").valueSetter = this.valueSetter4CustomerName;
      getColumnDef(columnDefs, "wholesaleRate").valueSetter = this.valueSetter4WholesaleRate;
      getColumnDef(columnDefs, "purchaseRate").valueSetter = this.valueSetter4PurchaseRate;
      getColumnDef(columnDefs, "delivery1").valueSetter = this.valueSetter4Delivery1;
      getColumnDef(columnDefs, "shipmentPlanDate").valueSetter = this.valueSetter4ShipmentPlanDate;
      return columnDefs;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;

      if (this.inputModel) {
        this.init(this.inputModel); 
      }

      var allColumnIds = this.columnApi.getAllColumns().map(col => col.colId);
      this.columnApi.autoSizeColumns(allColumnIds);
      this.gridApi.refreshCells();
    },
    onColumnEverythingChanged() {
      var allColumnIds = [];
      this.columnApi?.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.columnApi?.autoSizeColumns(allColumnIds);
      this.gridApi?.refreshCells();
    },
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();
    },
    onCellEditingStarted(event) {
      const popupTop = event.api.getCellEditorInstances()[0].getGui().style.top;
      event.api.getCellEditorInstances()[0].getGui().style.top = parseInt(popupTop) - 40 + "px";
    },
    valueSetter4WholesaleRate(params) {
      let isNumber = Validation.isRate(params.newValue);
      if (isNumber !== true) {
        this.$dialog.notify.error("卸掛率は" + isNumber, { timeout: 2300 });
        return false;
      }
      if (Number(params.newValue) < 0 || Number(params.newValue) > 100) {
        this.$dialog.notify.error("卸掛率は0～100の値を設定してください。", { timeout: 2300 });
        return false;
      }
      params.data.wholesaleRate = params.newValue;
      params.data.updateWholesaleRate = true;
      return true;
    },
    valueSetter4PurchaseRate(params) {
      let isNumber = Validation.isRate(params.newValue);
      if (isNumber !== true) {
        this.$dialog.notify.error("仕入掛率は" + isNumber, { timeout: 2300 });
        return false;
      }
      if (Number(params.newValue) < 0 || Number(params.newValue) > 100) {
        this.$dialog.notify.error("仕入掛率は0～100の値を設定してください。", { timeout: 2300 });
        return false;
      }
      params.data.purchaseRate = params.newValue;
      params.data.updatePurchaseRate = true;
      return true;
    },
    // ****************************
    // 画面アクション定義
    // ****************************
    init(inputModel) {
      this.updateModel = this.defaultModel;
      this.selectedProposition = this.inputHeader;
      this.updateSuccessRecords = [];

      this.settingSources = []; 
      this.onAddSettingSource();

      if (this.gridApi) {
        this.gridApi.setRowData(JSON.parse(JSON.stringify(inputModel)));
      }

      if (this.$refs.propositionDetailBulkEditForm) {
        this.$refs.propositionDetailBulkEditForm.resetValidation();
      }
    },
    reset() {
      this.init(this.inputModel);
      this.updateSuccessRecords = [];
    },
    onCancelClick() {
      this.$emit("onDialogClose", this.updateSuccessRecords);
    },
    async onUpdateClick() {
      this.loadingOn();
      await new Promise(resolve => setTimeout(resolve, 1000));
      var requestRecords = [];
      this.errorRows = [];
      var isValid = true;
      this.gridApi.forEachNode((record) => {
        var error = this.validateRow(record.data);
        if (error != true) {
          this.errorRows.push({
            propositionDetailId: record.data.propositionDetailId,
            errorMessage: error,
          });
          isValid = false;
        } else {
          const formatted = this.requestFormat(record.data);
          console.log("【送信直前データチェック】", formatted);
          requestRecords.push(formatted); 
        }
      });
      if (isValid) {
        try {
          this.loadingOn();
          var param = {
            propositionDetailList: requestRecords,
          };
          const response = await this.$store.dispatch("propositionDetail/bulkupdate", param);
          let error = response.data?.header;
          // 一覧更新レコード
          this.searchFlg = true;
          let updateRows = [];
          this.errorRows = [];
          switch (error.resultCode) {
            case ApiStatus.consts.SUCCESS:
            case ApiStatus.consts.BUSINESS_ERROR:
            case ApiStatus.consts.ALREADY_CHANGED:
              // エラーメッセージ格納
              if (error.messages) {
                Object.keys(error.messages).forEach((key) => {
                  this.errorRows.push({
                    propositionDetailId: key,
                    errorMessage: error.messages[key],
                  });
                });
              }
              // 一覧部の更新分のレコード設定
              if (response.data.contents) {
                this.gridApi.forEachNode((row) => {
                  response.data.contents.propositionDetailList.forEach((propositiondetail) => {
                    let isError = this.errorRows.some((r) => r.propositionDetailId === row.data.propositionDetailId);
                    if (propositiondetail.propositionDetailId == row.data.propositionDetailId && !isError) {
                      this.updateSuccessRecords.push(propositiondetail);
                      updateRows.push(propositiondetail);
                    }
                  });
                });
              }
              // エラー表示
              if (this.errorRows.length > 0) {
                // 確認ダイアログから更新した分を削除(エラーがある場合のみ)
                this.gridApi.applyTransaction({ remove: updateRows });
                this.$refs.updateErrorGrid.open({ records: this.errorRows });
                this.$dialog.notify.error(`委託・消化仕入明細の更新に失敗したデータが存在します。ご確認ください。`, {
                  timeout: 2300,
                });
              } else {
                this.$dialog.notify.info(`委託・消化仕入明細を更新しました`, { timeout: 2300 });
                this.$refs.updateErrorGrid.close();
                this.$emit("onEditSubmit", this.updateSuccessRecords);
                this.reset();
              }
              break;
            default:
              this.redirectError();
              break;
          }
        } catch (error) {
          console.error("propositionDetailBulkEdit_update::onSubmit", error);
          this.apiRequestError(error);
        } finally {
          this.loadingOff();
        }
      } else {
        this.$refs.updateErrorGrid.open({ records: this.errorRows });
        this.$dialog.notify.error(`更新データに入力エラーが存在します。ご確認ください。`, {
          timeout: 2300,
        });
      }
    },
    requestFormat(row) {
        row.propositionDetailId = String(row.propositionDetailId),
        row.propositionId = String(row.propositionId),
        row.customerCode = String(row.customerCode),
        row.productCode = String(row.productCode),
        row.entrustQuantity = Number(row.entrustQuantity),
        row.wholesaleRate = Number(row.wholesaleRate),
        row.purchaseRate = Number(row.purchaseRate),
        row.deliveryCode = row.delivery1?.deliveryCode || row.deliveryCode || "";
        row.directDeliveryRequestFlg = Boolean(row.directDeliveryRequestFlg),
        row.shipmentPlanDate = String(row.shipmentPlanDate),
        row.supplierDeliveryCd = String(row.supplierDeliveryCd),
        row.stockOwner = String(row.stockOwner),
        row.updateDatetime = row.updateDate
      return row;
    },
    async onCellValueChanged(params) {
      // セルの色を変えるため項目更新をチェック
      if (params.colDef.field == "customerName") {
        if (params.newValue && params.newValue.customerCode) {
          params.data.customerCode = params.newValue.customerCode;
          
          await this.setDeliveryList(params.data.customerCode);
          
          params.data.delivery1 = null; 
          params.data.deliveryCode = null;
          params.data.updateDelivery1 = false;
        }
        params.data.updateCustomerCode = true;
      } else if (params.colDef.field == "wholesaleRate") {
        params.data.updateWholesaleRate = true;
      } else if (params.colDef.field == "purchaseRate") {
        params.data.updatePurchaseRate = true;;
      } else if (params.colDef.field == "delivery1") {
        params.data.updateDelivery1 = true;
      } else if (params.colDef.field == "shipmentPlanDate") {
        params.data.updateShipmentPlanDate = true;
      }

      this.gridApi.applyTransaction({ update: [params.data] });
      this.gridApi.refreshCells({ force: true, rowNodes: [params.node] });
    },
    onSettingColSelected(index) {
      this.settingSources[index].value = "";
    },
    async onBulkCustomerChanged(val) {
      this.selectedBulkCustomerCode = val;
    },
    onAddSettingSource() {
      let settingSource = {
        column: 0,
        value: "",
      };
      this.settingSources.push(settingSource);
    },
    onDelSettingSource(index) {
      this.settingSources.splice(index, 1);
    },
    onBtnSetUpdate() {
      if (this.validate()) {
        this.selectedRows.forEach((row) => {
          this.settingSources.forEach((source) => {
            if (source.column === this.constant.propositionDetailBulkEditColumns.CUSTOMER_NAME) {
              const targetCust = this.customers.find(c => c.customerCode === source.value);
              if (targetCust) {
                // 取引先名
                row.customerCode = targetCust.customerCode;
                row.customerName = targetCust;
                row.updateCustomerCode = true;

                row.delivery1 = null;
                row.deliveryCode = null;
                row.updateDelivery1 = false; 

                this.setDeliveryList(row.customerCode);
              }
            } else if (source.column === this.constant.propositionDetailBulkEditColumns.WHOLESALE_RATE) {
              // 卸掛率
              row.wholesaleRate = source.value;
              row.updateWholesaleRate = true;
            } else if (source.column === this.constant.propositionDetailBulkEditColumns.PURCHASE_RATE) {
              // 仕入掛率
              row.purchaseRate = source.value;
              row.updatePurchaseRate = true;
            } else if (source.column === this.constant.propositionDetailBulkEditColumns.SUPPLIER_DELIVERY_CD) {
              // 配送先名
              if (this.Delivery) {
                row.delivery1 = {
                  value: this.Delivery,
                  text: this.Delivery.delivery2,
                  deliveryCode: this.Delivery.deliveryCode,
                  label: this.Delivery.delivery1 + " " + this.Delivery.delivery2,
                };
                row.deliveryCode = this.Delivery.deliveryCode;
                row.updateDelivery1 = true;
              }
            } else if (source.column === this.constant.propositionDetailBulkEditColumns.SHIP_PLAN_DATE) {
              // 出荷予定日
              row.shipmentPlanDate = source.value;
              row.updateShipmentPlanDate = true;
            }
          });
        });
        this.gridApi.applyTransaction({ update: this.selectedRows });
        this.updateModel = this.defaultModel;
      }
    },
    // ****************************
    // 共通業務処理
    // ****************************
    onQuantityChanged(row) {
      row.unitReturnPriceTotal = row.unitPrice * row.returnQuantity;
    },
    // ****************************
    // Validation定義
    // ****************************
    validate() {
      const isValid = this.$refs.propositionDetailBulkEditForm.validate();
      if (!isValid) {
        this.$dialog.error({ text: "入力エラーがあります", actions: ["OK"] });
      }
      return isValid;
    },
    validateRow(row) {
      var ret = true;
      var messages = [];
      // 卸掛率
      this.setValidMessage(this.rules.isRate(row.wholesaleRate), "卸掛率", messages);
      this.setValidMessage(this.rules.maxRateLength(3, 1)(row.wholesaleRate), "卸掛率", messages);
      this.setValidMessage(this.rules.rangeOfNumber(0, 100)(row.wholesaleRate), "卸掛率", messages);
      // 仕入掛率
      this.setValidMessage(this.rules.isRate(row.purchaseRate), "仕入掛率", messages);
      this.setValidMessage(this.rules.maxRateLength(3, 1)(row.purchaseRate), "仕入掛率", messages);
      this.setValidMessage(this.rules.rangeOfNumber(0, 100)(row.purchaseRate), "仕入掛率", messages);

      if (messages.length > 0) ret = messages;
      return ret;
    },
    validSelectColumn(value) {
      if (value == null) return true;
      if (this.settingSources.filter((settingSource) => settingSource.column === value).length > 1)
        return "同一項目が選択されています。";
      return true;
    },
    setValidMessage(check, culumnName, messages) {
      if (!(check === true)) messages.push(culumnName + "は" + check);
    },
    booleanFormat(value) {
      if (value == null || value == "") return false;
      if (value == "Y") return true;
      if (value == "N") return false;
      return Boolean(value);
    },
    async findCustomers(corporateCode) {
      try {
        this.loadingOn();
        const response = await this.$store.dispatch("customer/suggest", { CorporationCd: corporateCode });
        if (response.data.contents.customers) {
          this.customers = response.data.contents.customers.map(c => ({
            customerCode: c.customerCd,
            customerName: c.customerName,
            label: `${c.customerName}`,
            value: c.customerCode
          }));
        }
      } catch (error) {
        console.error("UserEntry::findCustomers", error);
        this.apiRequestError(error);
      } finally {
        this.loadingOff();
      }
    },
    async setDeliveryList(customerCode) {
      if (!customerCode) return;
      if (this.deliveries.some(d => d.groupCode === customerCode)) {
        return;
      }
      try {
        const response = await this.$store.dispatch("deliveryDestination/searchDelivery", {
          groupCode: customerCode,
        });        
        if (response.data?.contents?.deliveries) {
          const fetchedDeliveries = response.data.contents.deliveries;
          fetchedDeliveries.forEach((delivery) => {
            if (!this.deliveries.some(d => d.deliveryCode == delivery.deliveryCode && d.groupCode == customerCode)) {
              this.deliveries.push({
                value: delivery,
                text: delivery.delivery2,
                deliveryCode: delivery.deliveryCode,
                label: delivery.delivery1 + " " + delivery.delivery2,
                groupCode: customerCode
              });
            }
          });
        }
      } catch (error) {
        console.error("setDeliveryList error:", error);
      }
    },
    async getDeliveryList() {
      this.loadingOn();
      try {
        for (const row of this.deliveryGroupCodes) {
          if (row) {
            await this.setDeliveryList(row);
          }
        }
      } finally {
        this.loadingOff();
      }
    },
    setDeliveryName() {
      this.gridApi.forEachNode((node) => {
        const delivery = this.deliveries.find((row) => row.deliveryCode === node.data.deliveryCode);

        if (delivery) {
          node.data.delivery1 = delivery;
        } else {
          node.data.delivery1 = {
            value: null,
            text: node.data.delivery2,
            deliveryCode: node.data.deliveryCode,
            label: node.data.delivery1 + " " + node.data.delivery2,
          };
        }
      });
    },
    onDeliveryAllChanged() {
      const delivery = this.$refs.deliveryAll[0]?.selected();
      if (delivery) {
        this.Delivery = delivery;
      } else {
        this.Delivery = null;
      }
    },
    createDeliveryNameValue(value, valueObject) {
      return {
        value: valueObject,
        text: value?.delivery2,
        deliveryCode: value?.deliveryCode,
        label: value?.delivery1 + " " + value?.delivery2,
      };
    },
  },
  beforeMount() {
    this.deliveryGroupCodes = [...new Set(this.inputModel.map(row => row.customerCode))].filter(c => !!c);
    if (this.inputHeader && this.inputHeader.corporateCode) {
      this.findCustomers(this.inputHeader.corporateCode);
    }
    this.getDeliveryList();
    
    this.domLayout = "autoHeight";
    this.defaultColDef = {
      filter: "agTextColumnFilter",
      resizable: true,
      sortable: true,
      suppressSizeToFit: true,
      filterParams: {
        newRowsAction: "keep",
      },
      maxWidth: 300,
    };
    this.columnDefs = this.setColumnDefs();
  },
};
</script>
